import { pickups, pickupsInterior, cards, residencias } from './data';
import axios from 'axios';
import queryString from 'query-string';

/**
 * Get pickup information from data
 * @param {string} id Pickup identifier
 */
export const getPickupInfo = (value, zona) => {
  if (!value) return null;

  if (zona === 'Montevideo') {
    return pickups.filter(pickup => pickup.value === value)[0];
  } else {
    return pickupsInterior.filter(pickup => pickup.value === value)[0];
  }
};

export const STORE_NAME = 'itau-tc';

export const clearSessionStorage = () => window.sessionStorage.setItem(STORE_NAME, '{data:{}}');

// Redirigir a la landing SIN parametros
export function redirectToLanding() {
  const parsed = queryString.parse(window.location.search);
  const baseUrl = window.location.href.split('?')[0];

  if (Object.keys(parsed).length === 0 && parsed.constructor === Object) {
    window.location.href = baseUrl;
  } else {
    window.location.href = `${baseUrl}?${queryString.stringify(
      { ...parsed, grupo: null, tipo: null },
      { skipNull: true },
    )}`;
  }
}

export const breakpoints = {
  md: `${process.env.REACT_APP_MOBILE_BREAKPOINT}px`,
};

export const colors = {
  baseBackgroundColor: '#f9fafb',
  baseTextColor: '#26221f',
  baseFontText: "'ItauText', sans-serif",
  baseFontDisplay: "'ItauDisplay', sans-serif",
  orange: '#FF6200',
  darkOrange: '#dd6100',
  lightOrange: '#ed7e19',
  grey: '#c8c8c8',
  darkGrey: '#464646',
  lighterGrey: '#ededed',
  pale: '#efe9e5',
  lightestGrey: '#f5f5f5',
  borderRadius: '4px',
  white: '#fff',
  black: '#312d2b',
  blue: '#106eb0',
  textMuted: '#969290',
  boxShadow: '0 1px 2px 0 rgba(91, 81, 73, 0.2)',
  brown: '#5d5750',
  brown2: '#5e5852',
  inputBorderColor: '#d9d3cf',
  lightPink: '#faf8f7',
  gridGutter: '10px',
  formErrorColor: 'firebrick',
  outline: 0,
};

export function getCards(cardId) {
  return cards?.find(card => card.id === cardId);
}

export function getCardTypes(cardId, types) {
  return types?.find(card => card.id === cardId);
}

if (process.env.REACT_APP_ENV === 'testing') {
  window.urlAltasWebTarjetas = '/pub/altasWeb/tarjetas/enviar/2';
  window.urlAltasWebLikert = '/pub/altasWeb/likert';
  window.urlAltasWebTarjetasDocumentacion = '/pub/altasWeb/solicitudTarjeta/documentacion';
  window.urlAltasWebSolicitudTarjeta = '/pub/altasWeb/solicitudTarjeta';
  window.urlAltasWebSolicitudTarjetaCompleta = '/pub/altasWeb/solicitudTarjetaCompleta';
  window.urlAltasWebMostrarFormularioReferidos = '/pub/altasWeb/mostrar_formulario_referidos';
}

const BASE_URL = process.env.REACT_APP_BASE_URL || '';
const API_URL = BASE_URL + window.urlAltasWebTarjetas;
const API_URL_INICIAR_PLATINUM = BASE_URL + window.urlAltasWebSolicitudTarjeta;
const API_URL_ACTUALIZA_PLATINUM = BASE_URL + window.urlAltasWebSolicitudTarjetaCompleta;
const API_URL_CONSULTA_PLATINUM = BASE_URL + window.urlAltasWebSolicitudTarjeta;
const API_URL_SUBIR_ARCHIVO_PLATINUM = BASE_URL + window.urlAltasWebTarjetasDocumentacion;
const API_URL_LIKERT = BASE_URL + window.urlAltasWebLikert;
const API_URL_MOSTRAR_REFERIDOS = BASE_URL + window.urlAltasWebMostrarFormularioReferidos;

axios.defaults.paramsSerializer = params => {
  return Object.entries(params)
    .map(x => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
    .join('&');
};

export const submitForm = (data, captcha) => {
  let group = getCards(data.selectedGroup);
  let tipo = getCardTypes(data.selectedCard, group.types);

  let departamentoEntrega = data.entrega_department || '';
  let localidadEntrega = data.entrega_localidad || '';
  let domicilioEntrega = data.entrega_address || '';

  if (data.delivery === 'domicilio') {
    departamentoEntrega = data.department;
    localidadEntrega = data.localidad;
    domicilioEntrega = data.address;
  }

  if (data.delivery === 'Retiro' && data.pickup && data.zona) {
    let pickupInfo = getPickupInfo(data.pickup, data.zona);
    departamentoEntrega = pickupInfo.departamento;
    localidadEntrega = pickupInfo.localidad;
    domicilioEntrega = pickupInfo.address;
  }

  // Filtrar parametros con prefijo utm
  const parsed = queryString.parse(window.location.search);
  let utmParams = Object.keys(parsed)
    .filter(key => key.includes('utm_'))
    .reduce((obj, key) => {
      return {
        ...obj,
        [key]: parsed[key],
      };
    }, {});

  let req = {
    tipo: group.label, // 'Volar', etc
    fechaCierre: '26',
    nombre: removeAccentsAndSpecialChars(data.name),
    apellido: '-',
    documento: data.numero_cedula,
    programa: tipo.badge.title, // 'Regional', etc
    solProdTipoDoc: data.tipo_cedula,
    solProdDocumentoFolio: data.tipo_cedula === 'ci-vieja' ? data.folio_number : '',
    solProdDocumentoSerie: data.tipo_cedula === 'ci-vieja' ? data.folio_serie : '',
    solProdDocumentoCodSec: data.tipo_cedula === 'ci-nueva' ? data.cedula_codigo : '',
    telefonoContacto: data.phone,
    email: data.email,
    pais: 'Uruguay',
    departamento: data.department,
    localidad: data.localidad,
    domicilio: removeAccentsAndSpecialChars(data.address),
    preferencia:
      data.delivery === 'domicilio' || data.delivery === 'otra_direccion'
        ? 'Entrega'
        : data.delivery,
    lugarEntrega: data.delivery === 'domicilio' ? 'Misma dirección de contacto' : '',
    departamentoEntrega: departamentoEntrega,
    localidadEntrega: localidadEntrega,
    domicilioEntrega: removeAccentsAndSpecialChars(domicilioEntrega),
    horario: '',
    lugarRetiro: data.delivery === 'Retiro' ? data.pickup : '',
    departamentoRetiro: data.delivery === 'Retiro' ? data.zona : '',
    origen: data.origen || '',
    residencia: data.residencia || residencias[2].value,
    referidoDocumentoNro: data.hasReferred === 'yes' ? data.referrer_document_number : '',
    referidoDocumentoTipo: data.hasReferred === 'yes' ? data.referrer_document_type : '',
    contrataSeguroFraudes: data.contrataSeguroFraudes || false,

    ...utmParams,
  };

  return axios.post(API_URL, {}, {
    params: req,
    headers: { 'g-recaptcha-response': captcha },
  });
};

export const iniciaSolicitudPlatinum = data => {
  let group = getCards(data.selectedGroup);
  let tipo = getCardTypes(data.selectedCard, group.types);

  // Filtrar parametros con prefijo utm
  const parsed = queryString.parse(window.location.search);
  let utmParams = Object.keys(parsed)
    .filter(key => key.includes('utm_'))
    .reduce((obj, key) => {
      return {
        ...obj,
        [key]: parsed[key],
      };
    }, {});

  let mainParams = {
    campaign: utmParams.utm_campaign || '',
    content: utmParams.utm_content || '',
    medium: utmParams.utm_medium || '',
    source: utmParams.utm_source || '',
    term: utmParams.utm_term || '',
  };

  let req = {
    nombre: removeAccentsAndSpecialChars(data.name),
    apellido: removeAccentsAndSpecialChars(data.surname),
    celular: data.phone,
    codigoSeguridad: data.tipo_cedula === 'ci-nueva' ? data.cedula_codigo : '',
    grupoAfinidad: group.title.toUpperCase(),
    mail: data.email,
    numeroDocumento: data.numero_cedula,
    numeroFolio: data.tipo_cedula === 'ci-vieja' ? data.folio_number : 0,
    numeroSerie: data.tipo_cedula === 'ci-vieja' ? data.folio_serie : '',
    origen: data.origen || '',
    tipoCI: data.tipo_cedula === 'ci-vieja' ? 'Papel' : 'Electronico',
    tipoTarjeta: tipo.badge.title.toUpperCase(),

    ...mainParams,
  };

  return axios.post(API_URL_INICIAR_PLATINUM, req);
};

export const actualizaSolicitudPlatinum = (data, captcha) => {
  let departamentoEntrega = '-';
  let localidadEntrega = '-';
  let domicilioEntrega = '-';

  if (data.delivery !== 'domicilio') {
    departamentoEntrega = data.entrega_department;
    localidadEntrega = data.entrega_localidad;
    domicilioEntrega = data.entrega_address;
  }

  if (data.delivery === 'Retiro' && data.pickup && data.zona) {
    let pickupInfo = getPickupInfo(data.pickup, data.zona);
    departamentoEntrega = pickupInfo.departamento;
    localidadEntrega = pickupInfo.localidad;
    domicilioEntrega = pickupInfo.address;
  }

  let req = {
    apellido: '-',
    cierre: 'Dia3',
    codigoPostal: '',
    direccion: {
      codPostal: '',
      departamento: data.department,
      direccion: removeAccentsAndSpecialChars(data.address),
      direccionSolicitudId: data.solicitudId,
      localidad: data.localidad,
    },
    direccionEntrega: {
      codPostal: '',
      departamento: departamentoEntrega,
      direccion: removeAccentsAndSpecialChars(domicilioEntrega),
      direccionSolicitudId: data.solicitudId,
      localidad: localidadEntrega,
    },
    esPickUpCenter: data.delivery === 'Retiro' ? true : false,
    horarioEntrega: 'De10A14',
    nombre: removeAccentsAndSpecialChars(data.name),
    numeroDocumentoReferido: data.hasReferred === 'yes' ? data.referrer_document_number : '',
    pais: 'Uruguay',
    residencia: data.residencia || residencias[2].value,
    solicitudId: data.solicitudId,
    tipoDocumentoReferido: data.hasReferred === 'yes' ? data.referrer_document_type : '',
    usarMismaDireccionParaEntrega: data.delivery === 'domicilio' ? true : false,
    contrataSeguroFraudes: data.contrataSeguroFraudes || false,
  };

  return axios.put(API_URL_ACTUALIZA_PLATINUM, req, {
    headers: { 'g-recaptcha-response': captcha },
  });
};

export const consultarSolicitudPlatinum = solicitudId => {
  return axios.get(`${API_URL_CONSULTA_PLATINUM}/${solicitudId}`);
};

export const subirArchivoPlatinum = (solicitudId, archivoBase64, fileType, docType) => {
  let fileExtension;

  if (fileType == 'application/pdf') {
    fileExtension = 'pdf';
  } else if (fileType == 'image/jpeg' || fileType == 'image/jpg') {
    fileExtension = 'jpg';
  } else {
    fileExtension = 'otros';
  }

  let file = removeDataTypeFromBase64(archivoBase64);

  let req = {
    archivoBase64: file,
    extensionArchivo: fileExtension,
    type: docType,
  };

  return axios.post(`${API_URL_SUBIR_ARCHIVO_PLATINUM}/${solicitudId}`, req);
};

function removeDataTypeFromBase64(base64) {
  return base64.substr(base64.indexOf(',') + 1);
}

export const confirmarSubidaPlatinum = solicitudId => {
  return axios.put(`${API_URL_SUBIR_ARCHIVO_PLATINUM}/${solicitudId}`);
};

export const getMostrarReferidos = () => {
  return axios.get(API_URL_MOSTRAR_REFERIDOS);
};

export const likert = req => {
  return axios.post(API_URL_LIKERT, req);
};

export function validateFirstTwoDigits(str) {
  const regex = /^\d{2}/;
  return regex.test(str);
}

function removeAccentsAndSpecialChars(inputString) {
  const accentMap = {
    á: 'a',
    é: 'e',
    í: 'i',
    ó: 'o',
    ú: 'u',
    à: 'a',
    è: 'e',
    ì: 'i',
    ò: 'o',
    ù: 'u',
    â: 'a',
    ê: 'e',
    î: 'i',
    ô: 'o',
    û: 'u',
    ã: 'a',
    õ: 'o',
    ñ: 'n',
    ç: 'c',
    ü: 'u',
    ý: 'y',
    Á: 'A',
    É: 'E',
    Í: 'I',
    Ó: 'O',
    Ú: 'U',
    À: 'A',
    È: 'E',
    Ì: 'I',
    Ò: 'O',
    Ù: 'U',
    Â: 'A',
    Ê: 'E',
    Î: 'I',
    Ô: 'O',
    Û: 'U',
    Ã: 'A',
    Õ: 'O',
    Ñ: 'N',
    Ç: 'C',
    Ü: 'U',
    Ý: 'Y',
  };

  // Remove accents and special characters
  const cleanedString = inputString.replace(
    /[áéíóúàèìòùâêîôûãõñçüýÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÃÕÑÇÜÝ,./\\!@#$%^&*()_+|[\]{};:'"<>=?`~]/g,
    function(matched) {
      return accentMap[matched] || '';
    },
  );

  return cleanedString.replace(/[^a-zA-Z0-9\s]/g, '');
}
